import Freezer from 'freezer-js'

var state = {}

var store = new Freezer(state, {live: true})

export default store